import projectionGrid from 'projection-grid';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { columnChooserPlugin } from '@bingads-webui-campaign/projection-grid-column-chooser';
import { editablePlugin } from '@bingads-webui-campaign/projection-grid-editable';
import { projectionGridScopeNavigator } from '@bingads-webui-campaign/projection-grid-scope-navigator';
import { projectionGridScrollbarPlugin } from '@bingads-webui-campaign/projection-grid-scrollbar';
import { projectionGridFlexColumnResize } from '@bingads-webui-campaign/projection-grid-flex-column-resize';
import { jsdataRawDataPlugin } from '@bingads-webui-campaign/pgrid-js-data-raw-data';
import { toggleRadioButton } from '../selection-helper';

export class SeasonalityAdjustmentGridView extends DeterministicWrapperView {
  viewFactory({
    config,
    permissions,
    toolbarPlugin,
  }) {
    const gridFactory = projectionGrid
      .factory({ vnext: true })
      // For accurate grid init latency, PerfMarkerPlugin should be the first plugin to load.
      .use(perfMarkerPlugin)
      .use(a11yPlugin)
      .use(paginationPlugin)
      .use(placeholderPlugin)
      .use(uiBlockerPlugin)
      .use(toolbarPlugin.plugin)
      .use(columnChooserPlugin)
      .use(jsdataRawDataPlugin)
      .use(projectionGridScopeNavigator)
      .use(projectionGridScrollbarPlugin)
      .use(projectionGridFlexColumnResize);

    if (!permissions.IsReadOnlyUser) {
      gridFactory.use(editablePlugin);
    }

    this.grid = gridFactory.create(config);

    return this.grid.gridView;
  }

  get className() {
    return 'seasonality-adjustment-grid';
  }

  get events() {
    return {
      'click .td[data-column="selection"] input[type="radio"].select-row': e => toggleRadioButton(e, this.grid.gridView),
    };
  }
}
